import {
  Shield,
  Wrench,
  Anchor,
  Zap,
  BookOpen,
  Code,
} from "lucide-react";

/**
 * Maps icon names to their corresponding Lucide React components
 * This centralized mapping can be used across the application
 */
export const iconMap = {
  // Primary Lucide mappings
  'Shield': Shield,
  'Wrench': Wrench,
  'Anchor': Anchor,
  'Zap': Zap,
  'BookOpen': BookOpen,
  'Code': Code,
  
  // Legacy/fallback mappings for backward compatibility
  'HealthAndSafety': Shield,
  'OilBarrel': Wrench,
  'Bolt': Zap,
  'Build': Wrench,
  'MenuBook': BookOpen,
};

/**
 * Parses icon data from the backend and returns the appropriate React component
 * @param {string|object} iconData - Icon data from the backend, either as a JSON string or parsed object
 * @returns {Function|null} - The React component for the icon, or null if not found
 */
export const parseIconData = (iconData) => {
  if (!iconData) return null;
  
  try {
    // If it's a string, try to parse it as JSON
    const iconObj = typeof iconData === 'string' ? JSON.parse(iconData) : iconData;
    
    if (iconObj?.type === 'Lucide' && iconObj?.name) {
      return iconMap[iconObj.name] || null;
    }
    
    return null;
  } catch (error) {
    console.error('Error parsing icon data:', error);
    return null;
  }
};
